<template>
  <router-view v-if="(isUpdatePage || isCreatePage) && !visibleLoader" />

  <main v-else class="page pto">
    <AppBack :on-back="onBack" />

    <ThePagePreloader v-if="visibleLoader" position="small" />

    <section v-if="!isUpdatePage && !visibleLoader" class="section page__header">
      <AppTabsBtns :routes="showProjectsRoutes" />
    </section>

    <router-view v-if="!isUpdatePage && !visibleLoader" />
  </main>
</template>

<script>
import AppBack from '@/components/page/AppBack'
import AppTabsBtns from '@/components/page/tabs/AppTabsBtns'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import { mapActions, mapGetters } from 'vuex'
import { MIXIN_IS_UPDATE_PAGE } from '@/mixins/page/mixinIsUpdatePage'
import { goToPage, prevPage } from '@/utils/router'
import { PTO_PROJECT_DETAILED_PROJECT_ROUTE_NAME } from '@/data/pto/routes'

export default {
  name: 'PtoProjectDetailed',
  components: {
    AppBack,
    AppTabsBtns,
    ThePagePreloader
  },

  mixins: [MIXIN_IS_UPDATE_PAGE],

  data: () => ({
    projectsRoutes: [
      { name: 'PtoProjectPto', text: 'ПТО' },
      { name: 'PtoProjectEstimate', text: 'Сметный' },
      { name: 'PtoProjectDelivery', text: 'Снабжение' }
    ],
    fromRoute: null
  }),

  computed: {
    ...mapGetters('pto/project', {
      currentProjectId: 'getCurrentItemId',
      isLoading: 'getIsLoading',
      currentProject: 'getCurrentItem'
    }),

    visibleLoader () {
      return this.isLoading && !this.currentProjectId
    },

    showProjectsRoutes () {
      if (this.currentProject.is_no_materials) {
        return this.projectsRoutes.filter((item) => item.name !== 'PtoProjectDelivery')
      } else return this.projectsRoutes
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.name !== 'PtoObjectDetailed') return

      vm.fromRoute = {
        name: from.name,
        params: from.params
      }
    })
  },

  async mounted () {
    await Promise.all([
      this.loadOneItem(this.$route.params.projectId),
      this.GETBuildingList(),
      this.GETObjectList(),
      this.GETEstimateBaseTypeList(),
      this.GETHandbookIDList(),
      this.GETStatusProjectList()
    ])
  },

  destroyed () {
    this.fromRoute = null
  },

  methods: {
    ...mapActions('pto/project', {
      loadOneItem: 'loadOneItem'
    }),
    ...mapActions('handbook/pto', {
      GETBuildingList: 'GETBuildingList',
      GETObjectList: 'GETObjectList',

      GETEstimateBaseTypeList: 'GETEstimateBaseTypeList',
      GETHandbookIDList: 'GETHandbookIDList',
      GETStatusProjectList: 'GETStatusProjectList'
    }),
    onBack () {
      const routeName = this.$route.name

      if (routeName.includes('PtoProjectPto')) {
        return goToPage('PtoProjectDetailed', { projectId: this.$route.params.projectId })
      }

      if (PTO_PROJECT_DETAILED_PROJECT_ROUTE_NAME.includes(routeName)) {
        if (this.fromRoute) {
          return goToPage(this.fromRoute.name, this.fromRoute.params)
        }

        return goToPage('PtoProject')
      }

      if (routeName === 'PtoProjectEstimate') {
        return goToPage('PtoProjectUpdate')
      }

      return prevPage()
    }
  }
}
</script>
